module.exports = __webpack_public_path__ + "media/src/components/SiteFooter/cyber-essentials-badge-20a22f8641398c6c43a007347b5b60aa.png";